module.exports = __webpack_public_path__ + "static/img/che05.2f58488.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/che05.png
// module id = 9ntS
// module chunks = 1